import { useTranslation } from '@thoughtspot/i18n';
import React from 'react';
import { Content, CreateModal, Header } from '../../common';
import { LearnMore, Mode } from '../../common/constants';
import styles from '../backup-storage.module.scss';
import { actions, createSnapShotRowData, snapshotEmptyStateFormFields, } from '../common/backup-storage.util';
import { pageName, TranslationsKeys, } from '../common/constants';
import { TableListWrapperComponent } from '../common/table-list-wrapper';
export const SnapshotViewSection = ({ table, configState, isModalOpen, addClickHandler, rowDeleteClickHandler, confirmDeleteHandler, dismissModalHandler, updateTable, }) => {
    const { t } = useTranslation();
    const addSnapshotClickHandler = (type) => {
        addClickHandler(type);
    };
    const snapshotRowDeleteClickHandler = (snapshotName) => {
        rowDeleteClickHandler(snapshotName);
    };
    const snapshotConfirmDeleteHandler = () => {
        confirmDeleteHandler();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { title: t(TranslationsKeys.SNAPSHOT_TITLE), subTitle: t(TranslationsKeys.SNAPSHOT_DESCRIPTION), learnMoreKey: LearnMore.SNAPSHOT, titleSize: "medium", mode: Mode.VIEW, isFullWidth: true, actions: configState.actions, actionHandler: addSnapshotClickHandler }),
        isModalOpen && (React.createElement(CreateModal, { pageName: pageName, action: "deleteSnapshot", onConfirm: snapshotConfirmDeleteHandler, onDismiss: dismissModalHandler })),
        table.length > 0 ? (React.createElement("div", { className: styles.tableBottomMargin },
            React.createElement(TableListWrapperComponent, { rowData: createSnapShotRowData(table, snapshotRowDeleteClickHandler), typeName: "snapshot", updateTable: updateTable }))) : (React.createElement(Content, { key: `backupAndStorage_${Mode.VIEW}`, config: snapshotEmptyStateFormFields()[0], actions: actions, actionHandler: addSnapshotClickHandler, mode: Mode.VIEW, pageName: pageName, isFullWidth: true }))));
};
export const MemoizedSnapshot = React.memo(SnapshotViewSection);
//# sourceMappingURL=snapshot.js.map